import aes from 'crypto-js/aes'
import { lib } from 'crypto-js/core'
import { getRandomValues } from 'expo-crypto'

// Supply native random salt explicitly; CryptoJS cannot obtain it from Hermes.
export const encryptCache = ( data, key ) => {
	const salt = lib.WordArray.create( Array.from( getRandomValues( new Uint32Array( 2 ) ) ) );
	return aes.encrypt( data, key, { salt } ).toString();
};
